import React from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import { Accordion, AccordionDetails, AccordionSummary, Grid, Stack, Typography } from '@mui/material'
import { useState } from 'react'
import useDebounce from 'utils/customHook/useDebounce'
import SimpleSelectionTable from 'components/datatable/SimpleSelectionTable'
import { nbPerPageLabelTiny } from 'referencial/constants/ReferencialConstants'

const PluvioDataTypes = ({
    parameters = [],
    setParameters = () => {},
    getGlobalParameter = () => {},
    moduleParameters = [],
    setModuleParameters = () => {},
    getGlobalModuleParameter = () => {},
    pluviometryDataTypes = [],
    isGlobal = false,
}) => {
    const parameter = 'PLUVIOMETER_DATA_TYPE'

    const foundParameter = parameters.find(p => p.parameter === parameter)?.value
    const foundModuleParameter = moduleParameters.find(p => p.parameter === parameter)?.value

    const [pluvioDataType, setPluvioDataType] = useState(foundParameter ? foundParameter.split(',').map(e => Number(e)) : [])
    const [modulePluvioDataType, setModulePluvioDataType] = useState(foundModuleParameter ? foundModuleParameter.split(',').map(e => Number(e)) : [])

    const onChange = (e) => {
        if (isGlobal) {
            setPluvioDataType(e)
        } else {
            setModulePluvioDataType(e)
        }
    }

    const selectedList = isGlobal ? pluvioDataType : modulePluvioDataType

    useDebounce(() => {
        setParameters(prev => [
            ...prev.filter(p => p.parameter !== parameter),
            getGlobalParameter(parameter, `${pluvioDataType}`),
        ])
    }, 200, [pluvioDataType])

    useDebounce(() => {
        setModuleParameters(prev => [
            ...prev.filter(p => p.parameter !== parameter),
            getGlobalModuleParameter(parameter, `${modulePluvioDataType}`),
        ])
    }, 200, [modulePluvioDataType])

    return (
        <Grid size={12} justifyContent='space-between' alignItems='center' columnSpacing={1} spacing={1} paddingX={6}>
            <Accordion>
                <AccordionSummary>
                    {isGlobal ? i18n.dataTypes : i18n.dataTypesVisibleOnThisModule}
                </AccordionSummary>
                <AccordionDetails>
                    <Stack spacing={1}>
                        {!isGlobal && <Typography fontStyle='italic'>{i18n.configurationOfTheApplicationWillNotBeModified}</Typography>}
                        <SimpleSelectionTable
                            onChange={onChange}

                            listData={pluviometryDataTypes}
                            selectedList={selectedList}

                            listHeaders={['id', 'label']}
                            listTitle={i18n.nonSelectedParameters}
                            selectedListTitle={i18n.selectedParameters}

                            nbPerPage={nbPerPageLabelTiny}
                        />
                    </Stack>
                </AccordionDetails>
            </Accordion>
        </Grid>
    )
}

PluvioDataTypes.propTypes = {
    parameters: PropTypes.arrayOf(PropTypes.shape({})),
    setParameters: PropTypes.func,
    getGlobalParameter: PropTypes.func,
    moduleParameters: PropTypes.arrayOf(PropTypes.shape({})),
    setModuleParameters: PropTypes.func,
    getGlobalModuleParameter: PropTypes.func,
    pluviometryDataTypes: PropTypes.arrayOf(PropTypes.shape({})),
    isGlobal: PropTypes.bool,
}

export default PluvioDataTypes
